import React, { PropsWithChildren } from "react";

import { StyledViewContainer } from "./styles";

const ViewContainer = ({ children, viewProps: { height } }: PropsWithChildren<{ viewProps: any }>) => (
    <StyledViewContainer style={{ height }}>{children}</StyledViewContainer>
);

export default ViewContainer;
